import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef, HostListener } from "@angular/core";
import { Router } from '@angular/router';

import { AppClientContext } from '../../_appCommon/base/AppClientContext';
import { AppEventNames, SITEMAPURLS } from "../../_appCommon/base/Constants";
import { AuthenticationService } from '../../_dataservices/security/AuthenticationService';
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";
import { CategoryService } from 'src/app-client/_dataservices/category.service';
import { ProductDataService } from 'src/app-client/_dataservices/ProductDataService';
import { ShoppingCartDataService } from '../../_dataservices/ShoppingCartDataService';
import { SystemConfigDataService } from "src/app-client/_dataservices/SystemConfigDataService";
import { UrlQueryDef } from "src/app-client/_appCommon/base/UrlQueryDef";
import { ControllerBase } from "src/app-client/_appCommon/base/ControllerBase";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
  providers: [AuthenticationService, CategoryService, ProductDataService,SystemConfigDataService]
})
export class NavBarResponsiveComponent extends ControllerBase implements OnInit, AfterViewInit
{
  @ViewChild('shoppingCartButton') shoppingCartButton: ElementRef;

  @HostListener('window:resize', ['$event'])
  public resourceLink:string = "";
  public resourceLabel:string = "";
  onWindowResize()
  {
    if (this.getValidCollapseWindow())
    {
      this.shoppingCartButton.nativeElement.removeAttribute("data-bs-toggle");
    }
    else
    {
      this.shoppingCartButton.nativeElement.setAttribute("data-bs-toggle", 'collapse');
    }
  }

  public isCollapsed: boolean = false;
  public isUserLoggedIn = false;
  public mycategories: any[] = [];
  public shoppingCartCount: number = 0;
  public showShoppingCart: boolean = false;
  public sitemapUrls = SITEMAPURLS;
  public userName: string = "";
  public customerStatus: number = -1;
  public hasDentalMonitoringDoctorId: boolean = false;

  constructor(
    public authenticationService: AuthenticationService,
    public categoryService: CategoryService,
    public changeDetectorRef: ChangeDetectorRef,
    public productDataService: ProductDataService,
    public router: Router,
    public shoppingCartDataService: ShoppingCartDataService,
    public systemConfigDataService: SystemConfigDataService
  )
  {
    super();
  }

  ngOnInit()
  {
    this.getResourceLabel();
    this.getResourceLink();
    
    BroadcastManager.Instance.on(AppEventNames.OnCheckUserLoggedIn).subscribe(([e]) =>
    {
      if (e[0])
      {
        this.initializeUser();
      }
    });

    this.shoppingCartDataService.getItems()
      .subscribe(currentCar =>
      {
        this.shoppingCartCount = currentCar ? currentCar.length : 0;
      });

    this.shoppingCartDataService.showShoppingCart
      .subscribe(showShoppingCart =>
      {
        this.showShoppingCart = showShoppingCart;
      });
  }

  ngAfterViewInit()
  {
    this.categoryService.getAllCategories().subscribe((response) =>
    {
      for (let i = 0; i < response.totalRecords; i++)
      {
        this.mycategories.push({
          "categoryId": response.records[i].id,
          "categoryName": response.records[i].name
        });
      }
      this.changeDetectorRef.detectChanges();
    }, (error) =>
    {
      console.error(error.message);
    });

    if (this.getValidCollapseWindow())
    {
      if(this.shoppingCartButton)
      {
        this.shoppingCartButton.nativeElement.removeAttribute("data-bs-toggle");
      }
    }
  }

  private initializeUser():void
  {
    const user = AppClientContext.Instance.user;
    const customerStatus=AppClientContext.Instance.customerStatus;
    if (user)
    {
      this.userName = user.firstName;
      this.customerStatus = customerStatus;
      this.hasDentalMonitoringDoctorId = (user.dentalMonitoringExternalDoctorId != null && user.dentalMonitoringExternalDoctorProfileId != null)
    }
  }

  public onShoppingCartClick(event: any)
  {
    this.shoppingCartDataService.onShowShoppingCart(!this.showShoppingCart);
  }

  public getValidCollapseWindow()
  {
    return window.innerWidth > 990;
  }

  public onHandleClickLogout(): void
  {
    this.authenticationService.logout();
    this.router.navigate(["/"]);
  }

  public goToNewPage(url: string)
  {
    if (url === "tienda")
    {
      if (this.productDataService.productListCategoryId != -1)
      {
        this.productDataService.setProductListCategoryId(-1);
      }
      this.shoppingCartDataService.caseId = null;
      this.shoppingCartDataService.casePatientName = null;
    }
    this.router.navigate(["/ecommerce/" + url]);
  }

  public goToMyProfile()
  {
    this.router.navigate(["/ecommerce/mi-perfil"]);
  }

  public goToMyPurchases()
  {
    this.router.navigate(['/ecommerce/mis-compras']);
  }

  public goToMyStock(){
    this.router.navigate(['/ecommerce/mis-productos']);
  }

  public categoryClicked(cat: any)
  {
    this.productDataService.setProductListCategoryId(cat.categoryId);
    this.router.navigate(["/ecommerce/tienda"]);
  }
  public changePasswordClicked()
  {
    this.router.navigate(["/ecommerce/resetpassword"]);
  }

  public isOnOpenPayProcess(){
    return this.router.url == '/ecommerce/openpay';
  }

  public goToMySmartSTLRequest(){
    this.router.navigate(["/ecommerce/mis-solicitudes-smart-stl"]);
  }

  public getResourceLink()
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {
      key : 'ResourceLink'
    };
    this.systemConfigDataService.getSystemConfigValueByKey(queryDef)
    .subscribe((res)=>{
      this.resourceLink = res.value;
    })
  }

  public getResourceLabel()
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {
      key : 'ResourceLabel'
    };
    this.systemConfigDataService.getSystemConfigValueByKey(queryDef)
    .subscribe((res)=>{
      this.resourceLabel = res.value;
    })
  }

  openExternalLink() {
    if(this.resourceLink != null && this.resourceLink !="")
    {
      window.open(this.resourceLink, '_blank', 'noopener,noreferrer');
    }
    else
    {
      this.setInfoAlert("Opción no disponible por el momento");
    }
  }
}
